<template>
  <div id="page-user-view">
    <vs-alert
      color="danger"
      title="User Not Found"
      :active.sync="user_not_found"
    >
      <span
        >User record with id: {{ $route.params.tenantsId }} not found.
      </span>
    </vs-alert>

    <div id="user-data" v-if="CompanyInformation">
      <vx-card class="mb-base">
        <div class="vx-col w-full">
          <div class="flex items-end px-3 text-primary">
            <feather-icon
              svgClasses="w-6 h-6"
              icon="SettingsIcon"
              class="mr-2"
            />
            <span class="font-medium text-xl leading-none text-primary"
              >Company Settings</span
            >
          </div>
          <vs-divider />
        </div>
        <div class="vx-row">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Max Non tax</td>
                <td>{{ CompanyInformation.maximumNonTax }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Max Net Pay</td>
                <td>{{ CompanyInformation.maximumNetPay }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Daily Rate per Hour</td>
                <td>
                  <vs-checkbox
                    v-model="CompanyInformation.isPerHourDailyRate"
                    class="mr-4 mb-2"
                    :disabled="!isEdit"
                  />
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Maximum Non Tax</td>
                <td>
                  <vs-checkbox
                    v-model="CompanyInformation.isMaximumNonTax"
                    class="mr-4 mb-2"
                    :disabled="!isEdit"
                  />
                </td>
              </tr>

              <tr>
                <td class="font-semibold">Annual Working Days</td>
                <td>{{ CompanyInformation.annualWorkingDays }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Bank Account</td>
                <td>{{ CompanyInformation.bankAccount }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Hours in a Day</td>
                <td>{{ CompanyInformation.hoursInADay }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Employee Percentage</td>
                <td>{{ CompanyInformation.percentageEmployee }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Employer Percentage</td>
                <td>{{ CompanyInformation.percentageEmployer }}</td>
              </tr>
            </table>
          </div>
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">SSS Based on Gross</td>
                <td>
                  <vs-checkbox
                    v-model="CompanyInformation.isSSSBasedOnGross"
                    class="mr-4 mb-2"
                    :disabled="!isEdit"
                  />
                </td>
              </tr>
              <tr>
                <td class="font-semibold">EC Based on Gross</td>
                <td>
                  <vs-checkbox
                    v-model="CompanyInformation.isECBasedOnGross"
                    class="mr-4 mb-2"
                    :disabled="!isEdit"
                  />
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Pagibig Based on Gross</td>
                <td>
                  <vs-checkbox
                    v-model="CompanyInformation.isPagibigBasedOnGross"
                    class="mr-4 mb-2"
                    :disabled="!isEdit"
                  />
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Philhealth Based on Gross</td>
                <td>
                  <vs-checkbox
                    v-model="CompanyInformation.isPhilhealthBasedOnGross"
                    class="mr-4 mb-2"
                    :disabled="!isEdit"
                  />
                </td>
              </tr>

              <tr>
                <td class="font-semibold">Round Off</td>
                <td>{{ CompanyInformation.roundOff }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Timezone</td>
                <td>{{ CompanyInformation.timeZone }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Upper Limit Employee</td>
                <td>{{ CompanyInformation.upperLimitEmployee }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Upper Limit Employer</td>
                <td>{{ CompanyInformation.upperLimitEmployee }}</td>
              </tr>
            </table>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user_not_found: false,
      CompanyInformation: null,
      isEdit: false,
    };
  },
  created() {
    this.$vs.loading();
    this.tenantsId = this.$route.params.tenantsId;
    console.log("Tenants ID:", this.tenantsId);
    const payload = {
      pageNumber: 1,
      pageSize: -1,
      sortBy: "CreatedOn",
      sortOrder: "Desc",
    };
    this.$store
      .dispatch("tenants/getAllSettings", this.tenantsId)
      .then((res) => {
        this.$vs.loading.close();
        if (res.data && res.data.data) {
          this.CompanyInformation = JSON.parse(JSON.stringify(res.data.data));
          console.log("tenantsId:", this.CompanyInformation);
        } else {
          console.error("Error: No data received from the API");
        }
      })
      .catch((error) => {
        this.$vs.loading.close();
        console.error("Error fetching tenant settings:", error);
      });
  },
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 10px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}
</style>
